export default {
  setDataTransferObject(state, payload) {
    state.dataTransferObject = payload
  }
}
